import { useCallback, useMemo } from 'react';

/**
 * Última visita al feed de actividad, por navegador (decisión 6): vive en
 * localStorage y no se sincroniza entre dispositivos. Toda lectura/escritura va en
 * try/catch porque el almacenamiento puede estar bloqueado.
 *
 * `lastSeenAt` se lee una vez por (empresa, usuario) y no cambia al llamar `markSeen`,
 * para que el contador no desaparezca a media pantalla.
 */
export function useLastSeenActivity(tenantId: string, userId: string): {
  lastSeenAt: string | null;
  markSeen: () => void;
} {
  const key = `agrovid.activity.lastSeen.${tenantId}.${userId}`;

  const lastSeenAt = useMemo(() => {
    try { return localStorage.getItem(key); } catch { return null; }
  }, [key]);

  const markSeen = useCallback(() => {
    try { localStorage.setItem(key, new Date().toISOString()); } catch { /* sin almacenamiento: no se recuerda */ }
  }, [key]);

  return { lastSeenAt, markSeen };
}
